var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-4 ml-auto d-flex flex-row justify-content-end" },
    [
      _c(
        "div",
        { staticClass: "btn-group mt-3", attrs: { role: "group" } },
        [
          _vm._t("before"),
          _vm._v(" "),
          !_vm.disableEdit
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-info",
                  attrs: { disabled: _vm.isLoading, type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("edit", true)
                    }
                  }
                },
                [_vm._v("Bearbeiten "), _c("i", { staticClass: "fas fa-pen" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("center"),
          _vm._v(" "),
          !_vm.disableDelete
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-danger",
                  attrs: { disabled: _vm.isLoading, type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("delete")
                    }
                  }
                },
                [
                  _vm._v("Löschen "),
                  !_vm.isLoading
                    ? _c("i", { staticClass: "fas fa-trash" })
                    : _vm._e(),
                  _vm.isLoading
                    ? _c("i", { staticClass: "fas fa-spinner fa-spin" })
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("after")
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }